export enum Labels {
  VIP_OFFER = 'VIP Offers',
  ACTIVE_OFFERS = 'Active Offers',
  ACTIVE_OFFER = 'Active Offer',
  VIEW_MORE = 'VIEW MORE',
  VIEW_LESS = 'VIEW LESS',
  SUBSCRIBE = 'SUBSCRIBE',
  PAY = 'PAY ',
  NFT = 'NFT',
  SELECT_SUBSCRIPTION_PLAN = 'Select Subscription Plan to Review Details:',
  BENEFITS = 'Benefits',
  SELECT_DURATION = 'Select Duration',
  PRICE_FOR = 'Price For',
  COPY = 'Copy',
  REDEEM = 'Redeem',
  UNLOCK_OFFER = 'Unlock Offer',
  CANCEL = 'Cancel',
  SUBSCRIBE_PLAN = 'Subscribe',
  EXPIRED_ON = 'Valid Until',
  FREE = 'Free',
  UNLOCK_ABILITY_TO_PURCHASE = 'Unlock Ability to Purchase',
  RESTRICTED_CONTENT = 'Restricted <content>',
  INDIVIDUAL = 'individual',
  UNLOCK = 'Unlock',
  EVENT_CODE = 'Event Code',
  CONTENT_IS_ONLY_AVAILABLE_TO = 'This <content> is only available to be purchased by <buyer_text>',
  SELECT = 'SELECT',
  UNLOCK_OFFER_LOYALTY_PREFIX = 'Unlock with',
  UNLOCK_OFFER_WITH_POINTS_MODAL_HEADER = 'Unlock Offer with Points',
  POINTS = 'Points',
  OR = 'or',
  REDEMPTION_NOTES = 'Redemption Notes'
}
export enum Messages {
  UNLOCK_OFFER_BUY_NFT = 'To Unlock this [content] you have to buy NFT',
  FOLLOW_STEP_TO_UNLOCK_NFT = 'Follow These Steps to Unlock via NFT',
  USE_CHROME_DESKTOP_BROWSER = 'Use a Chrome Desktop Computer Browser',
  INSTALL_METAMASK_PLUGIN = 'Use a Chrome Desktop Computer Browser Download and Install the MetaMask Chrome Plugin',
  LOGIN_WALLET_CHOOSE_NFT = 'Login into your Wallet and choosy the chain that your NFT is in (e.g. Polygon)',
  GO_TO_EDIT_PREF_NFT_WALLET = 'Go to Edit Preferences > Connect my NFT Wallet',
  TO_UNLOCK_SUBSCRIBE_PLAN = "To be able to purchase this [content], please subscribe to one of [name]'s plans",
  TO_UNLOCK_OFFER_SUBSCRIBE_PLAN = " To Unlock this [content], please subscribe to one of [name]'s [planName] Plan.",
  DISCOUNT_PERCENT_OFF = '([discount]% off Monthly Price)',
  CODE_COPIED_SUCCESSFULLY = 'Code copied successfully',
  UNLOCKED_WITH_TYPE = 'Unlocked with a [type]',
  UNLOCKED_WITH_LOYALTY_POINTS = 'Unlocked with Points',
  OFFER_CODE_FREE = 'Offer code is Free',
  OFFER_CODE_UNLOCKED_WITH_EXISTING_SUBSCRIPTION = 'Offer code unlocked with existing subscription',
  OFFER_CODE_INDIVIDUAL = 'Unlocked with an individual purchase',
  NO_ACTIVE_OFFERS = 'No active offers found',
  EXCLUSIVE_CODE_UNLOCKED = 'Here is your exclusive code. Please copy it or write it down. Remember you should never share your code with anyone else',
}

export const VIP_OFFER_TYPE = {
  OFFLINE: 'offline'
} as const;
